export default [
  {
    name: 'Asesores',
    icon: 'mdi-face-agent',
    path: '/admin/consultant',
    component: () => import(/* webpackChunkName: "admin-consultant" */ './views/Consultants'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
  {
    name: 'Usuarios',
    icon: 'mdi-account-group',
    path: '/admin/user',
    component: () => import(/* webpackChunkName: "admin-consultant" */ './views/Users'),
    meta: {
      admin: true,
      adminToolbar: false,
      adminDrawer: true,
      tooltip: null,
    },
  },
];
